import { DocumentVersionToAccept } from '@eagle/core-data-types';
import { NormalizedTermsAndConditionsDocument } from './terms-and-conditions.types';

export const DEFAULT_LANGUAGE = 'en';

export const normalizeDocuments = (documents: DocumentVersionToAccept[], language = DEFAULT_LANGUAGE): NormalizedTermsAndConditionsDocument[] => {
  const result: NormalizedTermsAndConditionsDocument[] = [];

  for (const document of documents) {
    let selectedLanguage: string | undefined;

    if (document.language[language]) {
      selectedLanguage = language;
    } else if (document.language[DEFAULT_LANGUAGE]) {
      selectedLanguage = DEFAULT_LANGUAGE;
    } else {
      selectedLanguage = Object.keys(document.language)[0];
    }

    if (!selectedLanguage) {
      console.warn('Failed to resolve document language.', { document });
      continue;
    }

    result.push({ ...document, language: selectedLanguage, url: document.language[selectedLanguage] });
  }

  return result;
};
